/** @format */


import { Dashboard } from "./Dashboard"; //dashboard
import { StorageList } from "./Storage/StorageList"; // storage-list
import { EditStorage } from "./Storage/EditStorage"; // edit-storage

import { ProfitMarginList } from "./ProfitMargin/ProfitMarginList"; // profit-margin-list
import { AddProfitMargin } from "./ProfitMargin/AddProfitMargin"; // add-profit-margin
import { EditProfitMargin } from "./ProfitMargin/EditProfitMargin"; // edit-profit-margin

import { PackageMaster } from "./PackageMaster/PackageMaster"; // package-master
import { AddPackageMaster } from "./PackageMaster/AddPackageMaster"; // add-package-master
import { EditPackageMaster } from "./PackageMaster/EditPackageMaster"; // edit-package-master

import { Insurance } from "./Insurance/Insurance"; // insurance
import { EditInsurance } from "./Insurance/EditInsurance"; // edit-insurance
import { AddInsurance } from "./Insurance/AddInsurance"; // edit-insurance

import { CourierAdditionalCharges } from "./CourierAdditionalCharges/CourierAdditionalCharges"; //
import { AddCourierAdditonalCharges } from "./CourierAdditionalCharges/AddCourierAdditionalCharges";

import { AttributeAdditionalFees } from "./AttributeAdditionalFees/AttributeAdditionalFees"; //AttributeAdditionalFees

import { HsCodeAdditionalFees } from "./HsCodeAdditionalFees/HsCodeAdditionalFees"; //HsCodeAdditionalFees
import { AddHsCodeAdditionalFees } from "./HsCodeAdditionalFees/AddHsCodeAdditionalFees"; //AddHsCodeAdditionalFees

import { MarketplaceAdditionalCharges } from "./MarketplaceAdditionalCharges/MarketplaceAdditionalCharges"; //MarketplaceAdditionalCharges

import { HsCodeRemarks } from "./HsCodeRemarks/HsCodeRemarks"; //HsCodeRemarks
import { AddHsCodeRemarks } from "./HsCodeRemarks/AddHsCodeRemarks"; //AddHsCodeRemarks

import { HsCodeDutyTaxes } from "./HsCodeDutyTaxes/HsCodeDutyTaxes"; //HsCodeDutyTaxes

import CourierRates from "./CourierRates/CourierRates";

import { CrmList } from "./Location/CRM/CrmList"; //crm-list
import { AddCrm } from "./Location/CRM/AddCrm"; //add-crm
import { EditCrm } from "./Location/CRM/EditCrm"; //edit-crm

import { PickUpList } from "./Location/PickUps/PickUpList"; //pick-up-list
import { AddPickUp } from "./Location/PickUps/AddPickUp"; //add-pick-up
import { EditPickUp } from "./Location/PickUps/EditPickUp"; //edit-pick-up
import { ViewPickUp } from "./Location/PickUps/ViewPickUp"; //pickUp-details
import { PickUpDetails } from "./Location/PickUps/PickUpDetails"; //pickUp-details

import { TrackingList } from "./Location/Tracking/TrackingList"; //tracking-list
import { AddTracking } from "./Location/Tracking/AddTracking"; //add-traking
import { EditTracking } from "./Location/Tracking/EditTracking"; //edit-tracking
import { TrackingDetails } from "./Location/Tracking/TrackingDetails"; //tracking-details

import { JobList } from "./Location/JobCard/JobList"; //job-list
import { AddJobCard } from "./Location/JobCard/AddJobCard"; //add-job-card
import { EditJobCart } from "./Location/JobCard/EditJobCart"; //edit-job-card
import { ViewJobCart } from "./Location/JobCard/JobForms/ViewJobCart" // view-job-cart
import { FileReader } from "./Location/JobCard/JobForms/FileReader"; //edit-job-card
import { JobDetails } from "./Location/JobCard/JobDetails"; //job-details
import { ClosedJobList } from "./Location/JobCard/ClosedJobList"; //closed-job-list
import { DeletedJobList } from "./Location/JobCard/DeletedJobList"; //deleted-job-list

import { WarehouseUpdate } from "./Location/WarehouseUpdates/WarehouseUpdate"; //warehouse-update
import { EditWarehouseUpdate } from "./Location/WarehouseUpdates/EditWarehouseUpdate"; //edit-warehouse-update
import { AddWarehouseUpdate } from "./Location/WarehouseUpdates/AddWarehouseUpdate"; //add-warehouse-update
import { WarehouseUpdateDetails } from "./Location/WarehouseUpdates/WarehouseUpdateDetails"; //warehouse-update-details

import { SalesAgentList } from "./SalesAgent/SalesList"; //sales-agent-list
import { SalesAgentDetails } from "./SalesAgent/SalesAgentDetails"; //sales-agent-details
import { AddSalesAgent } from "./SalesAgent/AddSalesAgent"; //add-sales-agent
import { EditSalesAgent } from "./SalesAgent/EditSalesAgent"; //edit-sales-agent



import { OnlinePaymentRegisterDetail } from "./Operation/OnlinePaymentRegister/OnlinePaymentRegisterDetail"; //online-payment-register-detail

import { OnlinePaymentRegisterList } from "./Operation/OnlinePaymentRegister/OnlinePaymentRegisterList"; //online-payment-register-list





import { WarehouseList } from "./Warehouse/WarehouseList"; // warehoust-list
import { AddWarehouse } from "./Warehouse/AddWarehouse"; // add-warehouse
import { EditWarehouse } from "./Warehouse/EditWarehouse"; // edit-warehouse
import { WarehouseDetail } from "./Warehouse/WarehouseDetail"; // warehouse-detail

import {
  CountryList,
  AddCountry,
  EditCountry,
  PortList,
  AddPort,
  EditPort,
} from "./Location"; //add-country
import {
  AirConsolidationRateList,
  EditAirConsolidationRate,
  SeaConsolidationRateList,
  EditSeaConsolidationRate,
  AddSeaConsolidationRate,
  AddAirConsolidationRate,
  AirFreightRateList,
  AddAirFreightRate,
  EditAirFreightRate,
  AirFreightRateDetails,
  SeaFreightRateList,
  AddSeaFreightRate,
  EditSeaFreightRate,
  SeaFreightRateDetails,
  LandFreightRateList,
  AddLandFreightRate,
  LandFreightRateDetails,
  CourierFreightRateList,
  LandExpress,
  LandConsolidation,
} from "./FreightRate"; //air-freight-rate-list
// import {CourierFreightRateList} from "./FreightRate"
import {
  DomesticTariffList,
  AddDomesticTariff,
  EditDomesticTariff,
} from "./DomesticTariff"; //domestic-tariff-list
import {
  CourierOriginChargeList,
  AddCourierOriginCharge,
  EditCourierOriginCharge,
  AirOriginChargeList,
  AddAirOriginCharge,
  EditAirOriginCharge,
  AirOriginChargeDetails,
  SeaOriginChargeList,
  AddSeaOriginCharge,
  EditSeaOriginCharge,
  CrossBorderOriginChargeList,
  AddCrossBorderOriginCharge,
  EditCrossBorderOriginCharge,
  AirConsolidationOriginChargeList,
  AddAirConsolidationOriginCharge ,
  EditAirConsolidationOriginCharge ,
  SeaConsolidationOriginChargeList,
  AddSeaConsolidationOriginCharge,
  EditSeaConsolidationOriginCharge
} from "./localOriginCharge"; // local-origin-courier-charge-list
import { PromoList } from "./Promo/PromoList"; // promo-list
import { AddPromo } from "./Promo/AddPromo"; // add-promo
import { EditPromo } from "./Promo/EditPromo"; // edit-promo

import { VendorList } from "./Vendor/VendorList"; // vendor-list
import { AddVendor } from "./Vendor/AddVendor"; // add-vendor
import { EditVendor } from "./Vendor/EditVendor"; // edit-vendor


import { RetailerList } from "./Retailer/RetailerList"; // retailer-list
import { RetailerDetails } from "./Retailer/RetailerDetails"; // retailer-details
import { AddRetailer } from "./Retailer/AddRetailer"; // add-retailer
import { EditRetailer } from "./Retailer/EditRetailer"; // edit-retailer
import { AddStore } from "./Store/AddStore";
import { EditStore } from "./Store/EditStore";
import { StoreList } from "./Store/StoreList";

import { EditCorporates } from "./Corporates/EditCorporates"; // edit-corporates
import { CorporateDetails } from "./Corporates/CorporateDetails"; // edit-details
import { CorporatesList } from "./Corporates/CorporatesList"; // corporates-list
import { AddCorporates } from "./Corporates/AddCorporates"; // add-corporates

import { UsersList } from "./RegisteredUser/UsersList"; // user-list
import { AddUser } from "./RegisteredUser/AddUser"; // add-user

import { InvoicesList } from "./Operation/Invoice/InvoicesList"; //invoices-list
import { InvoiceDetail } from "./Operation/Invoice/InvoiceDetail"; //invoice-detail

import { AddQuotes } from "./Operation/QuoteDashboard/AddQuotes"; //add-quotes
import { EditQuotes } from "./Operation/QuoteDashboard/EditQuotes"; //edit-quotes
import { QuotesList } from "./Operation/QuoteDashboard/QuotesLIst"; //quotes-list

import { EnquiryManagementCRMList } from "./Operation/EnquiryManagementCRM/EnquiryManagementCRMList"; //enquiry-management-crm-list
import { AddEnquiry } from "./Operation/EnquiryManagementCRM/AddEnquiry"; //add-enquiry
import { EditEnquiry } from "./Operation/EnquiryManagementCRM/EditEnquiry"; //edit-enquiry
import { EnquiryDetails } from "./Operation/EnquiryManagementCRM/EnquiryDetails"; //enquiry-details

import { FollowUp } from "./Operation/Followupdata/FollowUp"; //follow-up

import { OutstandingJobs } from "./Operation/OutStandingJobs/OutstandingJobs"; //OutstandingJobs

import { IndividualList } from "./Individual/IndividualsList"; // individuals-list
import { AddIndividuals } from "./Individual/AddIndividual "; // add-individual
import { EditIndividuals } from "./Individual/EditIndividual "; // edit-individual //07-07-21
// import { IndividualDetail } from './Individual/IndividualDetail' // individual-detail
import { IndividualDetails } from "./Individual/IndividualDetails"; // individual-details

import { CommercialsList } from "./Commercial/CommercialsList"; // commercials-list
import { AddCommercial } from "./Commercial/AddCommercial"; // add-commercial
import { EditCommercial } from "./Commercial/EditCommercial"; // edit-commercial //07-07-21
import { CommercialDetails } from "./Commercial/CommercialDetails"; // edit-details


import { ReferralList } from "./Referral/ReferralList"; //referral-list



import { ProductList, AddProduct, EditProduct, ProductDetail } from "./Product"; // product-list


// import { InlandDestinationChargeList } from './InlandDestinationChargeList'
import { InlandDestinationChargeList } from "./DestinationCharges";
import { AirDestinationChargeList } from "./DestinationCharges";
import { AirDestinationConsolidationChargeList } from "./DestinationCharges";
import { SeaDestinationChargeList } from "./DestinationCharges";
import { SeaDestinationConsolidationChargeList } from "./DestinationCharges";

/// Courier country service
import { CourierCountryService } from "./Location/CourierCountryService/CourierCountryService";
import { AddCourierCountryService } from "./Location/CourierCountryService/AddCourierCountryService";
import { EditCourierCountryService } from "./Location/CourierCountryService/EditCourierCountryService";
import { CourierCountryServiceDetails } from "./Location/CourierCountryService/CourierCountryServiceDetails";



import { ErrorMargin } from "./ErrorMargin/ErrorMargin";
import { AddErrorMargin } from "./ErrorMargin/AddErrorMargin";

// Quickbook
import { Callback } from "./Quickbook/Callback"; //callback
import { InvoiceList } from "./Payinvoice/InvoiceList"; //invoice-list
import { InvoiceByJob } from "./Payinvoice/InvoiceByJob"; //invoice-list

// Pay Retailer
import { JobListRetailer } from "./PayRetailer/JobListRetailer"; //invoice-list-retailer

// Accounting
import { QuickbookAuth } from "./Accounting/QuickbookAuth"; //quickbook-auth


import { CustomerList } from "./Customers/CustomerList"; // customer-list
import {AssignAdvancePayment  } from "./Customers/AssignAdvancePayment"; // customer-list
import { JobAmountAssignList } from "./Payinvoice/JobAmountAssignList"; // job-amount-assign-list

// Reports
import { Performance } from './Reports/Performance' // performance
import { Shipment } from './Reports/Shipment' // shipment
import { RetailerPerformance } from './Reports/RetailerPerformance' // retailer-performance
import { RetailerPurchaseInvoice } from './Reports/RetailerPurchaseInvoice' // retailer-purchase-invoice
import { AddOns } from './Reports/AddOns' // add-ons
import { Vendors } from './Reports/Vendors' // vendors
import { RetailerIncentive } from './Reports/RetailerIncentive' // retailer-incentive
import { CustomerService } from './Reports/CustomerService' // customer-service
import { SalesTele } from './Reports/SalesTele' // sales-tele

import { TelrPaymentList } from "./Accounting/TelrPaymentList"; // telr-payment-list
import { TelrPaymentDetails } from "./Accounting/TelrPaymentDetails"; //telr-payment-details
import { CreditNoteList } from "./CreditNote/CreditNoteList"; //credit-note-list
import { AddCreditNote } from "./CreditNote/AddCreditNote"; // add-vendor

import { SalesAndCustomerServiceList } from "./CustomerService/CustomerServiceList"; // sales-and-customer-service-list
import { AddSalesAndCustomerService } from "./CustomerService/AddCustomerService"; // add-sales-and-customer-service
import { EditSalesAndCustomerService } from "./CustomerService/EditCustomerService"; // edit-sales-and-customer-service

// Category
import { CategoryList } from './Category/CategoryList'  // category-list

// sub-category-list
import { SubCategoryList } from './SubCategory/SubCategoryList'  // sub-category-list

// WebLinkRetailer
import  {WebLinkRetailerList} from './WebLinkRetailer/WebLinkRetailerList'  // web-Link-Retailer-List
import { AddWebLinkRetailer } from './WebLinkRetailer/AddWebLinkRetailer'  // add-web-Link-Retailer
import { EditWebLinkRetailer } from './WebLinkRetailer/EditWebLinkRetailer'  // add-web-Link-Retailer

// Enquiry
import { EnquiryList } from './Enquiry/EnquiryList'  // Enquiry-Lis
import { EnquiryView } from './Enquiry/EnquiryView'  // Enquiry-view

import { SubAdminList } from './Subadmin/SubAdminList'  // sub-admin-list
import { AddSubAdmin } from './Subadmin/AddSubAdmin'  // add-sub-admin
import { EditSubAdmin } from './Subadmin/EditSubAdmin'  // edit-sub-admin

import { DutyAndTaxList } from './DutyAndTax/DutyAndTaxList'  // duty-and-tax-list
import { AddDutyAndTax } from './DutyAndTax/AddDutyAndTax'  // add-duty-and-tax
import { EditDutyAndTax } from './DutyAndTax/EditDutyAndTax'  // edit-duty-and-tax

import { CrossBorderList } from './DestinationCrossBorder/CrossBorderList'  // cross-border-list
import { AddCrossBorder } from './DestinationCrossBorder/AddCrossBorder'  // add-cross-border
import { EditCrossBorder } from './DestinationCrossBorder/EditCrossBorder'  // edit-cross-border
import {InvoiceReport} from "./Reports/InvoiceReport";
import AddGallery from "./Gallery/AddGallery";
import Gallery from "./Gallery/Gallery";

import BlogList from "./Blog/BlogList"; //blog

import WoodenBoxCalculator from "./Calculator/WoodenBoxCalculator"; //WoodenBoxCalculator
import InsuranceCalculator from "./Calculator/InsuranceCalculator"; //InsuranceCalculator
import DutyAndTaxCalculator from "./Calculator/DutyAndTaxCalculator"; //DutyAndTaxCalculator

import FinanciallyClosedJobList from "./Location/JobCard/FinanciallyClosedJobList";
import TrackingReport from "./Reports/TrackingReport";
import FinancialJobReport from "./Reports/FinancialJobReport";
import CustomerReport from "./Reports/CustomerReport";
import {PickupTrackingList} from "./Location/PickUpTracking/PickupTrackingList";
import { PickupTrackingDetails } from "./Location/PickUpTracking/PickupTrackingDetails";
import { EditPickupTracking } from "./Location/PickUpTracking/EditPickupTracking";


import CourierPartnerList from "./CourierPartner/CourierPartnerList"; // CourierPartnerList
import AddCourierPartner from "./CourierPartner/AddCourierPartner"; // AddCourierPartner
import EditCourierPartner from "./CourierPartner/EditCourierPartner"; // EditCourierPartner
import { EditCreditNote } from "./CreditNote/EditCreditNote";

export const routes = [
  {accessGroup:"dashboard",Name:"Dashboard",Component:Dashboard},

  // master ---------------------------------------------------------------------------------------------------------------

  // Rate master ---------------------------------------------------------------------------------------

  // storage
  {accessGroup:"storage",Name:"StorageList",Component:StorageList},
  {accessGroup:"storage",Name:"EditStorage",Component:EditStorage},

  // profit master
  {accessGroup:"Profit_Margin",Name:"ProfitMarginList",Component:ProfitMarginList},
  {accessGroup:"Profit_Margin",Name:"AddProfitMargin",Component:AddProfitMargin},
  {accessGroup:"Profit_Margin",Name:"EditProfitMargin",Component:EditProfitMargin},

  // package
  {accessGroup:"package",Name:"PackageMaster",Component:PackageMaster},
  {accessGroup:"package",Name:"AddPackageMaster",Component:AddPackageMaster},
  {accessGroup:"package",Name:"EditPackageMaster",Component:EditPackageMaster},

  // insuranse
  {accessGroup:"insurance",Name:"Insurance",Component:Insurance},
  {accessGroup:"insurance",Name:"EditInsurance",Component:EditInsurance},
  {accessGroup:"insurance",Name:"AddInsurance",Component:AddInsurance},

  // Courier Additional Charges
  {accessGroup:"courier_additional_charges",Name:"CourierAdditionalCharges",Component:CourierAdditionalCharges},
  {accessGroup:"courier_additional_charges",Name:"AddCourierAdditonalCharges",Component:AddCourierAdditonalCharges},

  // Attribute Additional Fees
  {accessGroup:"attribute_additional_fees",Name:"AttributeAdditionalFees",Component:AttributeAdditionalFees},

  // HsCodeAdditionalFees Additional Fees
  {accessGroup:"hs_code_additional_fees",Name:"HsCodeAdditionalFees",Component:HsCodeAdditionalFees},
  {accessGroup:"hs_code_additional_fees",Name:"AddHsCodeAdditionalFees",Component:AddHsCodeAdditionalFees},

  // MarketplaceAdditionalCharges 
  {accessGroup:"marketplace_additional_charges",Name:"MarketplaceAdditionalCharges",Component:MarketplaceAdditionalCharges},
  
  
  // HsCodeAdditionalFees Additional Fees
  {accessGroup:"hs_code_remarks",Name:"HsCodeRemarks",Component:HsCodeRemarks},
  {accessGroup:"hs_code_remarks",Name:"AddHsCodeRemarks",Component:AddHsCodeRemarks},

  // HsCode Duty Taxes
  {accessGroup:"hs_code_duty_and_taxes",Name:"HsCodeDutyTaxes",Component:HsCodeDutyTaxes},

  // Courier Rates
  {accessGroup:"courier_rates",Name:"CourierRates",Component:CourierRates},

  // Error Margin
  {accessGroup:"error_margin",Name:"ErrorMargin",Component:ErrorMargin},
  {accessGroup:"error_margin",Name:"AddErrorMargin",Component:AddErrorMargin},

  // feright rates------------
  // air
  {accessGroup:"freight_rates",Name:"AirFreightRateList",Component:AirFreightRateList},
  {accessGroup:"freight_rates",Name:"AddAirFreightRate",Component:AddAirFreightRate},
  {accessGroup:"freight_rates",Name:"EditAirFreightRate",Component:EditAirFreightRate},
  {accessGroup:"freight_rates",Name:"AirFreightRateDetails",Component:AirFreightRateDetails},

  // air cosolidation
  {accessGroup:"freight_rates",Name:"AirConsolidationRateList",Component:AirConsolidationRateList},
  {accessGroup:"freight_rates",Name:"EditAirConsolidationRate",Component:EditAirConsolidationRate},
  {accessGroup:"freight_rates",Name:"AddAirConsolidationRate",Component:AddAirConsolidationRate},

  // sea
  {accessGroup:"freight_rates",Name:"SeaFreightRateList",Component:SeaFreightRateList},
  {accessGroup:"freight_rates",Name:"AddSeaFreightRate",Component:AddSeaFreightRate},
  {accessGroup:"freight_rates",Name:"EditSeaFreightRate",Component:EditSeaFreightRate},
  {accessGroup:"freight_rates",Name:"SeaFreightRateDetails",Component:SeaFreightRateDetails},

  // sea consolidation
  {accessGroup:"freight_rates",Name:"SeaConsolidationRateList",Component:SeaConsolidationRateList},
  {accessGroup:"freight_rates",Name:"EditSeaConsolidationRate",Component:EditSeaConsolidationRate},
  {accessGroup:"freight_rates",Name:"AddSeaConsolidationRate",Component:AddSeaConsolidationRate},

  // Courier Freight Rate List
  {accessGroup:"freight_rates",Name:"CourierFreightRateList",Component:CourierFreightRateList},

  // Land Express
  {accessGroup:"freight_rates",Name:"LandExpress",Component:LandExpress},

  // Land Consolidation
  {accessGroup:"freight_rates",Name:"LandConsolidation",Component:LandConsolidation},

   // origin charges------------
  // Domestic Tariff List
  {accessGroup:"origin_charges",Name:"DomesticTariffList",Component:DomesticTariffList},
  {accessGroup:"origin_charges",Name:"AddDomesticTariff",Component:AddDomesticTariff},
  {accessGroup:"origin_charges",Name:"EditDomesticTariff",Component:EditDomesticTariff},

  // Air Origin Charge List
  {accessGroup:"origin_charges",Name:"AirOriginChargeList",Component:AirOriginChargeList},
  {accessGroup:"origin_charges",Name:"AddAirOriginCharge",Component:AddAirOriginCharge},
  {accessGroup:"origin_charges",Name:"EditAirOriginCharge",Component:EditAirOriginCharge},
  {accessGroup:"origin_charges",Name:"AirOriginChargeDetails",Component:AirOriginChargeDetails},
  
  // Air Consolidation Origin Charge
  {accessGroup:"origin_charges",Name:"AirConsolidationOriginChargeList",Component:AirConsolidationOriginChargeList},
  {accessGroup:"origin_charges",Name:"AddAirConsolidationOriginCharge",Component:AddAirConsolidationOriginCharge},
  {accessGroup:"origin_charges",Name:"EditAirConsolidationOriginCharge",Component:EditAirConsolidationOriginCharge},

  // Sea Origin Charge 
  {accessGroup:"origin_charges",Name:"SeaOriginChargeList",Component:SeaOriginChargeList},
  {accessGroup:"origin_charges",Name:"AddSeaOriginCharge",Component:AddSeaOriginCharge},
  {accessGroup:"origin_charges",Name:"EditSeaOriginCharge",Component:EditSeaOriginCharge},

  // Sea Consolidation Origin Charge
  {accessGroup:"origin_charges",Name:"SeaConsolidationOriginChargeList",Component:SeaConsolidationOriginChargeList},
  {accessGroup:"origin_charges",Name:"AddSeaConsolidationOriginCharge",Component:AddSeaConsolidationOriginCharge},
  {accessGroup:"origin_charges",Name:"EditSeaConsolidationOriginCharge",Component:EditSeaConsolidationOriginCharge},

  // Courier Origin Charge List
  {accessGroup:"origin_charges",Name:"CourierOriginChargeList",Component:CourierOriginChargeList},
  {accessGroup:"origin_charges",Name:"AddCourierOriginCharge",Component:AddCourierOriginCharge},
  {accessGroup:"origin_charges",Name:"EditCourierOriginCharge",Component:EditCourierOriginCharge},

  // cross border
  {accessGroup:"origin_charges",Name:"CrossBorderOriginChargeList",Component:CrossBorderOriginChargeList},
  {accessGroup:"origin_charges",Name:"AddCrossBorderOriginCharge",Component:AddCrossBorderOriginCharge},
  {accessGroup:"origin_charges",Name:"EditCrossBorderOriginCharge",Component:EditCrossBorderOriginCharge},

   // destination charges------------
    //  inland
  {accessGroup:"destination_charges",Name:"InlandDestinationChargeList",Component:InlandDestinationChargeList},

  // air
  {accessGroup:"destination_charges",Name:"AirDestinationChargeList",Component:AirDestinationChargeList},

  // air consolidation
  {accessGroup:"destination_charges",Name:"AirDestinationConsolidationChargeList",Component:AirDestinationConsolidationChargeList},

  // sea
  {accessGroup:"destination_charges",Name:"SeaDestinationChargeList",Component:SeaDestinationChargeList},
  
  // sea consolidation
  {accessGroup:"destination_charges",Name:"SeaDestinationConsolidationChargeList",Component:SeaDestinationConsolidationChargeList},
  
  // cross border
  {accessGroup:"destination_charges",Name:"CrossBorderList",Component:CrossBorderList},
  {accessGroup:"destination_charges",Name:"AddCrossBorder",Component:AddCrossBorder},
  {accessGroup:"destination_charges",Name:"EditCrossBorder",Component:EditCrossBorder},



  // Profile master ---------------------------------------------------------------------------------------
  // customer------------
  // individual
  {accessGroup:"customer",Name:"IndividualList",Component:IndividualList},
  {accessGroup:"customer",Name:"AddIndividuals",Component:AddIndividuals},
  {accessGroup:"customer",Name:"EditIndividuals",Component:EditIndividuals},
  {accessGroup:"customer",Name:"IndividualDetails",Component:IndividualDetails},

  // retailer/corporates
  {accessGroup:"customer",Name:"RetailerList",Component:RetailerList},
  {accessGroup:"customer",Name:"RetailerDetails",Component:RetailerDetails},
  {accessGroup:"customer",Name:"AddRetailer",Component:AddRetailer},
  {accessGroup:"customer",Name:"EditRetailer",Component:EditRetailer},
  {accessGroup:"customer",Name:"AddStore",Component:AddStore},
  {accessGroup:"customer",Name:"EditStore",Component:EditStore},
  {accessGroup:"customer",Name:"StoreList",Component:StoreList},

  // warehouse---------
  {accessGroup:"warehouse",Name:"WarehouseList",Component:WarehouseList},
  {accessGroup:"warehouse",Name:"AddWarehouse",Component:AddWarehouse},
  {accessGroup:"warehouse",Name:"EditWarehouse",Component:EditWarehouse},
  {accessGroup:"warehouse",Name:"WarehouseDetail",Component:WarehouseDetail},

  // product---------
  {accessGroup:"product",Name:"ProductList",Component:ProductList},
  {accessGroup:"product",Name:"AddProduct",Component:AddProduct},
  {accessGroup:"product",Name:"EditProduct",Component:EditProduct},
  {accessGroup:"product",Name:"ProductDetail",Component:ProductDetail},
  
  // vendor---------
  {accessGroup:"vendors",Name:"VendorList",Component:VendorList},
  {accessGroup:"vendors",Name:"AddVendor",Component:AddVendor},
  {accessGroup:"vendors",Name:"EditVendor",Component:EditVendor},
  
  // add location ---------------------------------------------------------------------------------------------------------------
  // country---------
  {accessGroup:"country",Name:"CountryList",Component:CountryList},
  {accessGroup:"country",Name:"AddCountry",Component:AddCountry},
  {accessGroup:"country",Name:"EditCountry",Component:EditCountry},
  
  // port---------
  {accessGroup:"port",Name:"PortList",Component:PortList},
  {accessGroup:"port",Name:"AddPort",Component:AddPort},
  {accessGroup:"port",Name:"EditPort",Component:EditPort},
  
  // Courier Country Service---------
  {accessGroup:"courier_country_service",Name:"CourierCountryService",Component:CourierCountryService},
  {accessGroup:"courier_country_service",Name:"AddCourierCountryService",Component:AddCourierCountryService},
  {accessGroup:"courier_country_service",Name:"EditCourierCountryService",Component:EditCourierCountryService},
  {accessGroup:"courier_country_service",Name:"CourierCountryServiceDetails",Component:CourierCountryServiceDetails},
  
  // Promo---------
  {accessGroup:"promo",Name:"PromoList",Component:PromoList},
  {accessGroup:"promo",Name:"AddPromo",Component:AddPromo},
  {accessGroup:"promo",Name:"EditPromo",Component:EditPromo},
  
  // Duty And Tax List
  {accessGroup:"dutyandtax",Name:"DutyAndTaxList",Component:DutyAndTaxList},
  {accessGroup:"dutyandtax",Name:"AddDutyAndTax",Component:AddDutyAndTax},
  {accessGroup:"dutyandtax",Name:"EditDutyAndTax",Component:EditDutyAndTax},

  // operation ---------------------------------------------------------------------------------------------------------------
  // crm---------
  // enquiry management
  {accessGroup:"enquiry",Name:"EnquiryManagementCRMList",Component:EnquiryManagementCRMList},
  {accessGroup:"enquiry",Name:"AddEnquiry",Component:AddEnquiry},
  {accessGroup:"enquiry",Name:"EditEnquiry",Component:EditEnquiry},
  
  // active jobs
  {accessGroup:"jobs_bookings",Name:"JobList",Component:JobList},
  {accessGroup:"jobs_bookings",Name:"AddJobCard",Component:AddJobCard},
  {accessGroup:"jobs_bookings",Name:"EditJobCart",Component:EditJobCart},
  {accessGroup:"crm",Name:"ViewJobCart",Component:ViewJobCart},
  
  // closed jobs
  {accessGroup:"jobs_closed",Name:"ClosedJobList",Component:ClosedJobList},
  
  // deleted jobs
  {accessGroup:"jobs_deleted",Name:"DeletedJobList",Component:DeletedJobList},
  
  // follow up
  {accessGroup:"follow_up",Name:"FollowUp",Component:FollowUp},

  // Outstanding jobs
  {accessGroup:"outstanding_jobs",Name:"OutstandingJobs",Component:OutstandingJobs},

  // accounting---------
  // advance received
  {accessGroup:"advanced_received",Name:"CustomerList",Component:CustomerList},
  {accessGroup:"advanced_received",Name:"AssignAdvancePayment",Component:AssignAdvancePayment},
  {accessGroup:"advanced_received",Name:"JobAmountAssignList",Component:JobAmountAssignList},
  
  // received payment
  {accessGroup:"receive_payment",Name:"InvoiceList",Component:InvoiceList},
  {accessGroup:"receive_payment",Name:"InvoiceByJob",Component:InvoiceByJob},
  
  // Job List Retailer
  {accessGroup:"payout_retailer",Name:"JobListRetailer",Component:JobListRetailer},
  
  // Credit Note List
  {accessGroup:"credit_note",Name:"CreditNoteList",Component:CreditNoteList},
  {accessGroup:"credit_note",Name:"AddCreditNote",Component:AddCreditNote},
  {accessGroup:"credit_note",Name:"EditCreditNote",Component:EditCreditNote},
  
  // Financially Closed Job List
  {accessGroup:"financially_closed",Name:"FinanciallyClosedJobList", Component:FinanciallyClosedJobList},
  
  // report---------
  // performance
  {accessGroup:"performance",Name:"Performance",Component:Performance},
  
  // shipment wise performance
  {accessGroup:"shipment_wise_performance",Name:"Shipment",Component:Shipment},
  
  // add ons
  {accessGroup:"add_ons",Name:"AddOns",Component:AddOns},
  
  // Retailer/Customer Wise Performance
  {accessGroup:"retailer/Customer_wise_performance",Name:"RetailerPerformance",Component:RetailerPerformance},
  
  // Retailer Incentive
  {accessGroup:"retailer_incentive",Name:"RetailerIncentive",Component:RetailerIncentive},
  
  // Vendors
  {accessGroup:"vendor",Name:"Vendors",Component:Vendors},
  
  // Retailer Purchase Invoice
  {accessGroup:"retailer_purchase_inv_value",Name:"RetailerPurchaseInvoice",Component:RetailerPurchaseInvoice},
  
  // Invoice Report
  {accessGroup:"invoice_report",Name:"InvoiceReport",Component:InvoiceReport},
  
  // Customer Service
  {accessGroup:"customer_service",Name:"CustomerService",Component:CustomerService},
  
  // Sales/Tele Sales Report
  {accessGroup:"sales/tele_report",Name:"SalesTele",Component:SalesTele},
  
  // Tracking Report
  {accessGroup:"tracking_report",Name:"TrackingReport", Component:TrackingReport},
  
  // Financial Closed Job Report
  {accessGroup:"Financial_Job_Report",Name:"FinancialJobReport", Component:FinancialJobReport},

  // Customer Report
  {accessGroup:"customer_Report",Name:"CustomerReport", Component:CustomerReport},
  
  // pick up scheduler---------
  {accessGroup:"pick_up_scheduler",Name:"PickUpList",Component:PickUpList},
  {accessGroup:"pick_up_scheduler",Name:"AddPickUp",Component:AddPickUp},
  {accessGroup:"pick_up_scheduler",Name:"EditPickUp",Component:EditPickUp},
  {accessGroup:"pick_up_scheduler",Name:"ViewPickUp",Component:ViewPickUp},
  {accessGroup:"pick_up_scheduler",Name:"PickUpDetails",Component:PickUpDetails},
  
  // tracking---------
  {accessGroup:"tracking",Name:"TrackingList",Component:TrackingList},
  {accessGroup:"tracking",Name:"AddTracking",Component:AddTracking},
  {accessGroup:"tracking",Name:"EditTracking",Component:EditTracking},
  { accessGroup: "tracking", Name: "TrackingDetails", Component: TrackingDetails },
  
    // pickup tracking---------
  {accessGroup:"PickupTrackingList",Name:"PickupTrackingList",Component:PickupTrackingList},
  {accessGroup:"PickupTrackingDetails",Name:"PickupTrackingDetails",Component:PickupTrackingDetails},
  {accessGroup:"EditPickupTracking",Name:"EditPickupTracking",Component:EditPickupTracking},
  
  // Telr Payment List---------
  {accessGroup:"online_transaction",Name:"TelrPaymentList",Component:TelrPaymentList},
  {accessGroup:"online_transaction",Name:"TelrPaymentDetails",Component:TelrPaymentDetails},
  
  // web link ---------------------------------------------------------------------------------------------------------------
  // category---------
  {accessGroup:"category",Name:"CategoryList",Component:CategoryList},

  // sub category---------
  {accessGroup:"sub_category",Name:"SubCategoryList",Component:SubCategoryList},
  
  // Web Link Retailer List---------
  {accessGroup:"web_link_retailer",Name:"WebLinkRetailerList",Component:WebLinkRetailerList},
  {accessGroup:"web_link_retailer",Name:"AddWebLinkRetailer",Component:AddWebLinkRetailer},
  {accessGroup:"web_link_retailer",Name:"EditWebLinkRetailer",Component:EditWebLinkRetailer},
  
  // Enquiry
  {accessGroup:"weblink_enquiry",Name:"EnquiryList",Component:EnquiryList},
  {accessGroup:"weblink_enquiry",Name:"EnquiryView",Component:EnquiryView},
  
  // Sub Admin
  {accessGroup:"admin",Name:"SubAdminList",Component:SubAdminList},
  {accessGroup:"admin",Name:"AddSubAdmin",Component:AddSubAdmin},
  {accessGroup:"admin",Name:"EditSubAdmin",Component:EditSubAdmin},
  
  // gallery
  {accessGroup:"gallery",Name:"Gallery",Component:Gallery},
  {accessGroup:"gallery",Name:"AddGallery",Component:AddGallery},
  
  // blog
  {accessGroup:"blogs",Name:"BlogList",Component:BlogList},

  // calculator
  {accessGroup:"wooden_box_calculator",Name:"WoodenBoxCalculator",Component:WoodenBoxCalculator},
  {accessGroup:"insurance_calculator",Name:"InsuranceCalculator",Component:InsuranceCalculator},
  {accessGroup:"duty_and_tax_calculator",Name:"DutyAndTaxCalculator",Component:DutyAndTaxCalculator},


  // courier partners
  {accessGroup:"courier_partners",Name:"CourierPartnerList",Component:CourierPartnerList },
  {accessGroup:"courier_partners",Name:"AddCourierPartner",Component:AddCourierPartner } ,
  {accessGroup:"courier_partners",Name:"EditCourierPartner",Component:EditCourierPartner },



  
  
  // Rate master ------------commented---------------------------------------------------------------------------------------------------
  {accessGroup:"enquiry",Name:"EnquiryDetails",Component:EnquiryDetails},
  {accessGroup:"rate_master",Name:"LandFreightRateList",Component:LandFreightRateList},
  {accessGroup:"rate_master",Name:"AddLandFreightRate",Component:AddLandFreightRate},
  {accessGroup:"rate_master",Name:"LandFreightRateDetails",Component:LandFreightRateDetails},
  {accessGroup:"profile_master",Name:"SalesAndCustomerServiceList",Component:SalesAndCustomerServiceList},
  {accessGroup:"profile_master",Name:"AddSalesAndCustomerService",Component:AddSalesAndCustomerService},
  {accessGroup:"profile_master",Name:"EditSalesAndCustomerService",Component:EditSalesAndCustomerService},
  {accessGroup:"all",Name:"EditCorporates",Component:EditCorporates},
  {accessGroup:"all",Name:"CorporateDetails",Component:CorporateDetails},
  {accessGroup:"all",Name:"CorporatesList",Component:CorporatesList},
  {accessGroup:"all",Name:"AddCorporates",Component:AddCorporates},
  {accessGroup:"jobs_bookings",Name:"JobDetails",Component:JobDetails},
  {accessGroup:"accounts",Name:"QuickbookAuth",Component:QuickbookAuth},
  {accessGroup:"all",Name:"CrmList",Component:CrmList},
  {accessGroup:"all",Name:"AddCrm",Component:AddCrm},
  {accessGroup:"all",Name:"EditCrm",Component:EditCrm},
  {accessGroup:"all",Name:"FileReader",Component:FileReader},
  {accessGroup:"all",Name:"WarehouseUpdate",Component:WarehouseUpdate},
  {accessGroup:"all",Name:"EditWarehouseUpdate",Component:EditWarehouseUpdate},
  {accessGroup:"all",Name:"AddWarehouseUpdate",Component:AddWarehouseUpdate},
  {accessGroup:"all",Name:"WarehouseUpdateDetails",Component:WarehouseUpdateDetails},
  {accessGroup:"all",Name:"SalesAgentList",Component:SalesAgentList},
  {accessGroup:"all",Name:"SalesAgentDetails",Component:SalesAgentDetails},
  {accessGroup:"all",Name:"AddSalesAgent",Component:AddSalesAgent},
  {accessGroup:"all",Name:"EditSalesAgent",Component:EditSalesAgent},
  {accessGroup:"all",Name:"OnlinePaymentRegisterDetail",Component:OnlinePaymentRegisterDetail},
  {accessGroup:"all",Name:"OnlinePaymentRegisterList",Component:OnlinePaymentRegisterList},
  {accessGroup:"all",Name:"UsersList",Component:UsersList},
  {accessGroup:"all",Name:"AddUser",Component:AddUser},
  {accessGroup:"all",Name:"InvoicesList",Component:InvoicesList},
  {accessGroup:"all",Name:"InvoiceDetail",Component:InvoiceDetail},
  {accessGroup:"all",Name:"AddQuotes",Component:AddQuotes},
  {accessGroup:"all",Name:"EditQuotes",Component:EditQuotes},
  {accessGroup:"all",Name:"QuotesList",Component:QuotesList},
  {accessGroup:"all",Name:"CommercialsList",Component:CommercialsList},
  {accessGroup:"all",Name:"AddCommercial",Component:AddCommercial},
  {accessGroup:"all",Name:"EditCommercial",Component:EditCommercial},
  {accessGroup:"all",Name:"CommercialDetails",Component:CommercialDetails},
  {accessGroup:"all",Name:"ReferralList",Component:ReferralList},
  {accessGroup:"all",Name:"Callback",Component:Callback},

]


